import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { ProductOrderDto } from 'src/dtos/productOrder/ProductOrderDto';
import { getData } from 'src/utils/axios/serverHelper';

const baseUrl = `${config.apiUrl}/productOrder`;

export const getProductOrderPopupList = async (
	searchText: string,
	compCd: string,
	workplaceCd: string,
	closeTag: string,
) => {
	return getData<ResponseDto<ProductOrderDto[]>>(`${baseUrl}/modal`, {
		params: {
			searchText: searchText || '',
			compCd: compCd || '',
			workplaceCd: workplaceCd || '',
			closeTag: closeTag || '',
		},
	});
};
